import { validateNumber } from 'ember-changeset-validations/validators';

export default {
  target_value: validateNumber({ integer: true, allowBlank: true }),
};
